import React from "react";
import styles from "../../styles/Videos/Premiumbanner.module.css";
import { useNavigate } from "react-router-dom";
const PremiumCourseBanner = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };

  return (
    <div className={styles.premiumCourseBanner}>
      <div className={styles.premiumCourseBannerContent}>
        <div>
          <img src="/premium.svg" alt="premium-courses-img" />
        </div>
        <div>
          <div className={styles.premiumCourseTitle}>Premium Courses</div>
          <div className={styles.premiumCourseFirstDescription}>
            Elevate Your Startup Journey
          </div>
          <div className={styles.premiumCourseDescription}>
            Master the Skills, Strategies, and Systems for Unstoppable Growth.
            Whether you're launching, scaling, or optimizing, our premium
            courses provide the insights, frameworks, and hands-on guidance you
            need to succeed.
          </div>
          <div className={styles.stepsContainer}>
            <div className={styles.step}>
              <img src="/check.svg" alt="check-icon" height={28} width={28} />
              <div>Proven Strategies from Industry Leaders</div>
            </div>
            <div className={styles.step}>
              <img src="/check.svg" alt="check-icon" height={28} width={28} />
              <div>Actionable Playbooks & Real-World Case Studies</div>
            </div>
            <div className={styles.step}>
              <img src="/check.svg" alt="check-icon" height={28} width={28} />
              <div>On-Demand & Interactive Learning</div>
            </div>
          </div>
          <div className={styles.btn}>
          <a href="https://personalgrowthhacker.in/" target="_blank" style={{color:"white",textDecoration:"none"}} rel="noreferrer">
            Get Started
          </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumCourseBanner;
